import React from "react";
import Container from "../../../utils/Container";
import H2 from "../../../elements/titles/H2";
import ButtonHref from "../../../elements/buttons/ButtonHref";
import Paragraph from "../../../elements/p/Paragraph";

const CallToAction = () => {
  return (
    <Container classe="separedSection md:flex justify-between items-center relative bg-secondary md:px-10 py-16 md:py-20">
      <div className="absolute left-[50%] hidden h-44 w-0.5 bg-white md:block"></div>
      <div className="col-span-5">
        <H2 color="primary" classe="text-center md:text-left">
          Ton ordinateur complet à <br className="hidden md:block" /> un prix
          njoh !!
        </H2>
      </div>
      <div className="mt-6 flex flex-col justify-center md:mt-0 md:block md:w-[47%] md:justify-start">
        <Paragraph color="light" classe="text-center md:text-left">
          New tech informatique met à votre disposition des appareils
          technologiques de qualité et de dernière génération avec une
          performance hors pair.
        </Paragraph>
        <ButtonHref
          target="_blanck"
          href="https://wa.me/237674651112"
          classe="mt-6 block mx-auto md:mx-auto"
        >
          Envoyer un message
        </ButtonHref>
      </div>
    </Container>
  );
};

export default CallToAction;
